export const enquiryReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ENQUIRIES_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        enquiries: null,
      };
    }
    case "GET_ENQUIRIES_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        enquiries: action.payload.data,
      };
    }
    case "GET_ENQUIRIES_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        enquiries: action.payload,
      };
    }
    case "GET_USER_ENQUIRIES_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        userEnquiries: null,
      };
    }
    case "GET_USER_ENQUIRIES_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        userEnquiries: action.payload.data,
      };
    }
    case "GET_USER_ENQUIRIES_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        userEnquiries: action.payload,
      };
    }
    case "VIEW_ENQUIRY_REQUEST": {
      return {
        ...state,
        loading: true,
        enquiryDetails: null,
      };
    }
    case "VIEW_ENQUIRY_SUCCESS": {
      return {
        ...state,
        loading: false,
        enquiryDetails: action.payload.data,
      };
    }
    case "VIEW_ENQUIRY_FAILED": {
      return {
        ...state,
        loading: false,
        enquiryDetails: action.payload,
      };
    }
    default:
      return state;
  }
};
